/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { HandlerRevert, HandlerRevertInterface } from "../HandlerRevert";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "ContractAddressNotWhitelisted",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToTokenProperties",
    outputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "isSet",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "externalDecimals",
            type: "uint8",
          },
        ],
        internalType: "struct ERCHandlerHelpers.Decimals",
        name: "decimals",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "virtualIncreaseBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60a060405234801561001057600080fd5b5060405161067f38038061067f83398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b6080516105ed6100926000396000818161012301526102c901526105ed6000f3fe608060405234801561001057600080fd5b50600436106100935760003560e01c8063318c136e11610066578063318c136e1461011e578063ac607c2114610145578063c238eea1146101da578063e248cff2146101ed578063fa8675b01461020057600080fd5b806307b7ed99146100985780630968f264146100ad5780630a6d55d8146100be57806330f08abd14610104575b600080fd5b6100ab6100a63660046103c6565b61025b565b005b6100ab6100bb3660046103fe565b50565b6100e76100cc3660046104af565b6000602081905290815260409020546001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b61010c601281565b60405160ff90911681526020016100fb565b6100e77f000000000000000000000000000000000000000000000000000000000000000081565b6101a26101533660046103c6565b600160208181526000928352604092839020805492810154845180860190955260029091015460ff81811615158652610100918290048116938601939093529293828216939091049091169084565b6040805194855292151560208086019190915291151592840192909252815115156060840152015160ff16608082015260a0016100fb565b6100ab6101e83660046104af565b600255565b6100ab6101fb366004610511565b61026c565b6100ab61020e36600461055d565b60008481526020818152604080832080546001600160a01b0319166001600160a01b03881690811790915583526001918290529091208581558101805461ffff1916909117905550505050565b6102636102be565b6100bb81610338565b6002546102b95760405162461bcd60e51b815260206004820152601660248201527514dbdb595d1a1a5b99c8189859081a185c1c195b995960521b60448201526064015b60405180910390fd5b505050565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146103365760405162461bcd60e51b815260206004820152601e60248201527f73656e646572206d7573742062652062726964676520636f6e7472616374000060448201526064016102b0565b565b6001600160a01b0381166000908152600160208190526040909120015460ff16610380576040516325df77c560e11b81526001600160a01b03821660048201526024016102b0565b6001600160a01b0316600090815260016020819052604090912001805461ff001916610100179055565b80356001600160a01b03811681146103c157600080fd5b919050565b6000602082840312156103d857600080fd5b6103e1826103aa565b9392505050565b634e487b7160e01b600052604160045260246000fd5b60006020828403121561041057600080fd5b813567ffffffffffffffff8082111561042857600080fd5b818401915084601f83011261043c57600080fd5b81358181111561044e5761044e6103e8565b604051601f8201601f19908116603f01168101908382118183101715610476576104766103e8565b8160405282815287602084870101111561048f57600080fd5b826020860160208301376000928101602001929092525095945050505050565b6000602082840312156104c157600080fd5b5035919050565b60008083601f8401126104da57600080fd5b50813567ffffffffffffffff8111156104f257600080fd5b60208301915083602082850101111561050a57600080fd5b9250929050565b60008060006040848603121561052657600080fd5b83359250602084013567ffffffffffffffff81111561054457600080fd5b610550868287016104c8565b9497909650939450505050565b6000806000806060858703121561057357600080fd5b84359350610583602086016103aa565b9250604085013567ffffffffffffffff81111561059f57600080fd5b6105ab878288016104c8565b9598949750955050505056fea26469706673582212207204d4a039f2f1d2e0f9108b5b11dcc68772ad41c343fa51340b79c3706f4ae764736f6c634300080b0033";

type HandlerRevertConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HandlerRevertConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HandlerRevert__factory extends ContractFactory {
  constructor(...args: HandlerRevertConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "HandlerRevert";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<HandlerRevert> {
    return super.deploy(
      bridgeAddress,
      overrides || {}
    ) as Promise<HandlerRevert>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): HandlerRevert {
    return super.attach(address) as HandlerRevert;
  }
  connect(signer: Signer): HandlerRevert__factory {
    return super.connect(signer) as HandlerRevert__factory;
  }
  static readonly contractName: "HandlerRevert";
  public readonly contractName: "HandlerRevert";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HandlerRevertInterface {
    return new utils.Interface(_abi) as HandlerRevertInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HandlerRevert {
    return new Contract(address, _abi, signerOrProvider) as HandlerRevert;
  }
}
